module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 16);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("@tkey/common-types");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/regenerator");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("bn.js");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/asyncToGenerator");

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/toConsumableArray");

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/classCallCheck");

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/createClass");

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = require("json-stable-stringify");

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = require("@toruslabs/eccrypto");

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/typeof");

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = require("web3-utils");

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/getPrototypeOf");

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inherits");

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/possibleConstructorReturn");

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "AuthMetadata", function() { return /* reexport */ src_authMetadata; });
__webpack_require__.d(__webpack_exports__, "default", function() { return /* reexport */ core; });
__webpack_require__.d(__webpack_exports__, "CoreError", function() { return /* reexport */ errors; });
__webpack_require__.d(__webpack_exports__, "lagrangeInterpolatePolynomial", function() { return /* reexport */ lagrangeInterpolatePolynomial; });
__webpack_require__.d(__webpack_exports__, "lagrangeInterpolation", function() { return /* reexport */ lagrangeInterpolation; });
__webpack_require__.d(__webpack_exports__, "generateRandomPolynomial", function() { return /* reexport */ generateRandomPolynomial; });
__webpack_require__.d(__webpack_exports__, "polyCommitmentEval", function() { return /* reexport */ polyCommitmentEval; });
__webpack_require__.d(__webpack_exports__, "Metadata", function() { return /* reexport */ src_metadata; });

// EXTERNAL MODULE: external "@babel/runtime/helpers/classCallCheck"
var classCallCheck_ = __webpack_require__(6);
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/createClass"
var createClass_ = __webpack_require__(7);
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(4);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);

// EXTERNAL MODULE: external "@tkey/common-types"
var common_types_ = __webpack_require__(0);

// EXTERNAL MODULE: external "json-stable-stringify"
var external_json_stable_stringify_ = __webpack_require__(8);
var external_json_stable_stringify_default = /*#__PURE__*/__webpack_require__.n(external_json_stable_stringify_);

// EXTERNAL MODULE: external "web3-utils"
var external_web3_utils_ = __webpack_require__(11);

// EXTERNAL MODULE: external "@babel/runtime/helpers/assertThisInitialized"
var assertThisInitialized_ = __webpack_require__(13);
var assertThisInitialized_default = /*#__PURE__*/__webpack_require__.n(assertThisInitialized_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/inherits"
var inherits_ = __webpack_require__(14);
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/possibleConstructorReturn"
var possibleConstructorReturn_ = __webpack_require__(15);
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/getPrototypeOf"
var getPrototypeOf_ = __webpack_require__(12);
var getPrototypeOf_default = /*#__PURE__*/__webpack_require__.n(getPrototypeOf_);

// CONCATENATED MODULE: ./src/errors.ts








function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = getPrototypeOf_default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf_default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn_default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }


/**
 * CoreError, extension for Error using CustomError
 * details: github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
 *
 * Usage:
 * 1. throw CoreError.metadataUndefined() // regularly used errors
 * 2. throw CoreError.fromCode(1304); // throw via code
 * 3. throw new CoreError(1000, "share indexes should be unique"); // for scarce errors
 *
 * Guide:
 * 1000 - core
 * 2000 - security questions
 * 3000 - webstorage
 * 4000 - common types (code reserved for future implementation)
 * 5000 - private key
 * 6000 - seed phrase
 * 7000 - share serialization
 * 8000 - share transfer
 */

var errors_CoreError = /*#__PURE__*/function (_TkeyError) {
  inherits_default()(CoreError, _TkeyError);

  var _super = _createSuper(CoreError);

  function CoreError(code, message) {
    var _this;

    classCallCheck_default()(this, CoreError);

    // takes care of stack and proto
    _this = _super.call(this, code, message); // Set name explicitly as minification can mangle class names

    Object.defineProperty(assertThisInitialized_default()(_this), "name", {
      value: "CoreError"
    });
    return _this;
  }

  createClass_default()(CoreError, null, [{
    key: "fromCode",
    value: function fromCode(code) {
      var extraMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      return new CoreError(code, "".concat(CoreError.messages[code], " ").concat(extraMessage));
    }
  }, {
    key: "default",
    value: function _default() {
      var extraMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return new CoreError(1000, "".concat(CoreError.messages[1000], " ").concat(extraMessage));
    } // Custom methods
    // Metadata

  }, {
    key: "metadataUndefined",
    value: function metadataUndefined() {
      var extraMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return CoreError.fromCode(1101, extraMessage);
    }
  }, {
    key: "metadataGetFailed",
    value: function metadataGetFailed() {
      var extraMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return CoreError.fromCode(1102, extraMessage);
    }
  }, {
    key: "metadataPostFailed",
    value: function metadataPostFailed() {
      var extraMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return CoreError.fromCode(1103, extraMessage);
    } // TkeyData

  }, {
    key: "tkeyStoreInvalid",
    value: function tkeyStoreInvalid() {
      var extraMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return CoreError.fromCode(1201, extraMessage);
    }
  }, {
    key: "tkeyEncryptionFailed",
    value: function tkeyEncryptionFailed() {
      var extraMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return CoreError.fromCode(1202, extraMessage);
    }
  }, {
    key: "tkeyDecryptionFailed",
    value: function tkeyDecryptionFailed() {
      var extraMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return CoreError.fromCode(1203, extraMessage);
    } // Shares

  }, {
    key: "privateKeyUnavailable",
    value: function privateKeyUnavailable() {
      var extraMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return CoreError.fromCode(1301, extraMessage);
    }
  }, {
    key: "unableToReconstruct",
    value: function unableToReconstruct() {
      var extraMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return CoreError.fromCode(1302, extraMessage);
    }
  }, {
    key: "incorrectReconstruction",
    value: function incorrectReconstruction() {
      var extraMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return CoreError.fromCode(1303, extraMessage);
    }
  }, {
    key: "encryptedShareStoreUnavailable",
    value: function encryptedShareStoreUnavailable() {
      var extraMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return CoreError.fromCode(1306, extraMessage);
    } // Metadata locks

  }, {
    key: "acquireLockFailed",
    value: function acquireLockFailed() {
      var extraMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return CoreError.fromCode(1401, extraMessage);
    }
  }, {
    key: "releaseLockFailed",
    value: function releaseLockFailed() {
      var extraMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return CoreError.fromCode(1402, extraMessage);
    }
  }]);

  return CoreError;
}(common_types_["TkeyError"]);

defineProperty_default()(errors_CoreError, "messages", {
  1000: "Custom",
  // Misc
  1001: "Unable to delete service provider share",
  1002: "Wrong share index",
  // metadata
  1101: "metadata not found, SDK likely not intialized",
  1102: "getMetadata errored",
  1103: "setMetadata errored",
  // tkeystore
  1201: "Invalid tkeyStore",
  1202: "Encryption failed",
  1203: "Decryption failed",
  // shares
  1301: "Private key not available. Please reconstruct key first",
  1302: "Unable to reconstruct",
  1303: "reconstructed key is not pub key",
  1304: "Share found in unexpected polynomial",
  1305: "Input is not supported",
  1306: "no encrypted share store for share exists",
  1307: "Share doesn't exist",
  // lock
  1401: "Unable to acquire lock",
  1402: "Unable to release lock"
});

/* harmony default export */ var errors = (errors_CoreError);
// EXTERNAL MODULE: external "@babel/runtime/helpers/toConsumableArray"
var toConsumableArray_ = __webpack_require__(5);
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/asyncToGenerator"
var asyncToGenerator_ = __webpack_require__(3);
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator_);

// EXTERNAL MODULE: external "@babel/runtime/regenerator"
var regenerator_ = __webpack_require__(1);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator_);

// EXTERNAL MODULE: external "bn.js"
var external_bn_js_ = __webpack_require__(2);
var external_bn_js_default = /*#__PURE__*/__webpack_require__.n(external_bn_js_);

// EXTERNAL MODULE: external "@toruslabs/eccrypto"
var eccrypto_ = __webpack_require__(9);

// CONCATENATED MODULE: ./src/lagrangeInterpolatePolynomial.ts






var lagrangeInterpolatePolynomial_generateEmptyBNArray = function generateEmptyBNArray(length) {
  return Array.from({
    length: length
  }, function () {
    return new external_bn_js_default.a(0);
  });
};

var lagrangeInterpolatePolynomial_denominator = function denominator(i, innerPoints) {
  var result = new external_bn_js_default.a(1);
  var xi = innerPoints[i].x;

  for (var j = innerPoints.length - 1; j >= 0; j -= 1) {
    if (i !== j) {
      var tmp = new external_bn_js_default.a(xi);
      tmp = tmp.sub(innerPoints[j].x);
      tmp = tmp.umod(common_types_["ecCurve"].curve.n);
      result = result.mul(tmp);
      result = result.umod(common_types_["ecCurve"].curve.n);
    }
  }

  return result;
};

var lagrangeInterpolatePolynomial_interpolationPoly = function interpolationPoly(i, innerPoints) {
  var coefficients = lagrangeInterpolatePolynomial_generateEmptyBNArray(innerPoints.length);
  var d = lagrangeInterpolatePolynomial_denominator(i, innerPoints);

  if (d.cmp(new external_bn_js_default.a(0)) === 0) {
    throw errors["default"]("Denominator for interpolationPoly is 0");
  }

  coefficients[0] = d.invm(common_types_["ecCurve"].curve.n);

  for (var k = 0; k < innerPoints.length; k += 1) {
    var newCoefficients = lagrangeInterpolatePolynomial_generateEmptyBNArray(innerPoints.length);

    if (k !== i) {
      var j = void 0;

      if (k < i) {
        j = k + 1;
      } else {
        j = k;
      }

      j -= 1;

      for (; j >= 0; j -= 1) {
        newCoefficients[j + 1] = newCoefficients[j + 1].add(coefficients[j]);
        newCoefficients[j + 1] = newCoefficients[j + 1].umod(common_types_["ecCurve"].curve.n);
        var tmp = new external_bn_js_default.a(innerPoints[k].x);
        tmp = tmp.mul(coefficients[j]);
        tmp = tmp.umod(common_types_["ecCurve"].curve.n);
        newCoefficients[j] = newCoefficients[j].sub(tmp);
        newCoefficients[j] = newCoefficients[j].umod(common_types_["ecCurve"].curve.n);
      }

      coefficients = newCoefficients;
    }
  }

  return coefficients;
};

var lagrangeInterpolatePolynomial_pointSort = function pointSort(innerPoints) {
  var pointArrClone = toConsumableArray_default()(innerPoints);

  pointArrClone.sort(function (a, b) {
    return a.x.cmp(b.x);
  });
  return pointArrClone;
};

var lagrangeInterpolatePolynomial_lagrange = function lagrange(unsortedPoints) {
  var sortedPoints = lagrangeInterpolatePolynomial_pointSort(unsortedPoints);
  var polynomial = lagrangeInterpolatePolynomial_generateEmptyBNArray(sortedPoints.length);

  for (var i = 0; i < sortedPoints.length; i += 1) {
    var coefficients = lagrangeInterpolatePolynomial_interpolationPoly(i, sortedPoints);

    for (var k = 0; k < sortedPoints.length; k += 1) {
      var tmp = new external_bn_js_default.a(sortedPoints[i].y);
      tmp = tmp.mul(coefficients[k]);
      polynomial[k] = polynomial[k].add(tmp);
      polynomial[k] = polynomial[k].umod(common_types_["ecCurve"].curve.n);
    }
  }

  return new common_types_["Polynomial"](polynomial);
};

function lagrangeInterpolatePolynomial(points) {
  return lagrangeInterpolatePolynomial_lagrange(points);
}
function lagrangeInterpolation(shares, nodeIndex) {
  if (shares.length !== nodeIndex.length) {
    throw errors["default"]("shares not equal to nodeIndex length in lagrangeInterpolation");
  }

  var secret = new external_bn_js_default.a(0);

  for (var i = 0; i < shares.length; i += 1) {
    var upper = new external_bn_js_default.a(1);
    var lower = new external_bn_js_default.a(1);

    for (var j = 0; j < shares.length; j += 1) {
      if (i !== j) {
        upper = upper.mul(nodeIndex[j].neg());
        upper = upper.umod(common_types_["ecCurve"].curve.n);
        var temp = nodeIndex[i].sub(nodeIndex[j]);
        temp = temp.umod(common_types_["ecCurve"].curve.n);
        lower = lower.mul(temp).umod(common_types_["ecCurve"].curve.n);
      }
    }

    var delta = upper.mul(lower.invm(common_types_["ecCurve"].curve.n)).umod(common_types_["ecCurve"].curve.n);
    delta = delta.mul(shares[i]).umod(common_types_["ecCurve"].curve.n);
    secret = secret.add(delta);
  }

  return secret.umod(common_types_["ecCurve"].curve.n);
} // generateRandomPolynomial - determinisiticShares are assumed random

function generateRandomPolynomial(degree, secret, deterministicShares) {
  var actualS = secret;

  if (!secret) {
    actualS = Object(common_types_["generatePrivateExcludingIndexes"])([new external_bn_js_default.a(0)]);
  }

  if (!deterministicShares) {
    var poly = [actualS];

    for (var i = 0; i < degree; i += 1) {
      var share = Object(common_types_["generatePrivateExcludingIndexes"])(poly);
      poly.push(share);
    }

    return new common_types_["Polynomial"](poly);
  }

  if (!Array.isArray(deterministicShares)) {
    throw errors["default"]("deterministic shares in generateRandomPolynomial should be an array");
  }

  if (deterministicShares.length > degree) {
    throw errors["default"]("deterministicShares in generateRandomPolynomial should be less or equal than degree to ensure an element of randomness");
  }

  var points = {};
  deterministicShares.forEach(function (share) {
    points[share.shareIndex.toString("hex")] = new common_types_["Point"](share.shareIndex, share.share);
  });

  for (var _i = 0; _i < degree - deterministicShares.length; _i += 1) {
    var shareIndex = Object(common_types_["generatePrivateExcludingIndexes"])([new external_bn_js_default.a(0)]);

    while (points[shareIndex.toString("hex")] !== undefined) {
      shareIndex = Object(common_types_["generatePrivateExcludingIndexes"])([new external_bn_js_default.a(0)]);
    }

    points[shareIndex.toString("hex")] = new common_types_["Point"](shareIndex, new external_bn_js_default.a(Object(eccrypto_["generatePrivate"])()));
  }

  points["0"] = new common_types_["Point"](new external_bn_js_default.a(0), actualS);
  return lagrangeInterpolatePolynomial(Object.values(points));
} //  2 + 3x = y | secret for index 1 is 5 >>> g^5 is the commitment | now we have g^2, g^3 and 1, |

function polyCommitmentEval(polyCommitments, index) {
  // convert to base points, this is badly written, its the only way to access the point rn zzz TODO: refactor
  var basePtPolyCommitments = [];

  for (var i = 0; i < polyCommitments.length; i += 1) {
    var key = common_types_["ecCurve"].keyFromPublic({
      x: polyCommitments[i].x.toString("hex"),
      y: polyCommitments[i].y.toString("hex")
    }, "");
    basePtPolyCommitments.push(key.getPublic());
  }

  var shareCommitment = basePtPolyCommitments[0];

  for (var _i2 = 1; _i2 < basePtPolyCommitments.length; _i2 += 1) {
    var factor = index.pow(new external_bn_js_default.a(_i2)).umod(common_types_["ecCurve"].n);

    var e = basePtPolyCommitments[_i2].mul(factor);

    shareCommitment = shareCommitment.add(e);
  }

  return new common_types_["Point"](shareCommitment.getX(), shareCommitment.getY());
}
// CONCATENATED MODULE: ./src/metadata.ts












var metadata_Metadata = /*#__PURE__*/function () {
  function Metadata(input) {
    classCallCheck_default()(this, Metadata);

    defineProperty_default()(this, "pubKey", void 0);

    defineProperty_default()(this, "publicPolynomials", void 0);

    defineProperty_default()(this, "publicShares", void 0);

    defineProperty_default()(this, "polyIDList", void 0);

    defineProperty_default()(this, "generalStore", void 0);

    defineProperty_default()(this, "tkeyStore", void 0);

    defineProperty_default()(this, "scopedStore", void 0);

    defineProperty_default()(this, "nonce", void 0);

    this.publicPolynomials = {};
    this.publicShares = {};
    this.generalStore = {};
    this.tkeyStore = {};
    this.scopedStore = {};
    this.pubKey = input;
    this.polyIDList = [];
    this.nonce = 0;
  }

  createClass_default()(Metadata, [{
    key: "getShareIndexesForPolynomial",
    value: function getShareIndexesForPolynomial(polyID) {
      return Object.keys(this.publicShares[polyID]);
    }
  }, {
    key: "getLatestPublicPolynomial",
    value: function getLatestPublicPolynomial() {
      return this.publicPolynomials[this.polyIDList[this.polyIDList.length - 1]];
    }
  }, {
    key: "addPublicPolynomial",
    value: function addPublicPolynomial(publicPolynomial) {
      var polyID = publicPolynomial.getPolynomialID();
      this.publicPolynomials[polyID] = publicPolynomial;
      this.polyIDList.push(polyID);
    }
  }, {
    key: "addPublicShare",
    value: function addPublicShare(polynomialID, publicShare) {
      if (!(polynomialID in this.publicShares)) {
        this.publicShares[polynomialID] = {};
      }

      this.publicShares[polynomialID][publicShare.shareIndex.toString("hex")] = publicShare;
    }
  }, {
    key: "setGeneralStoreDomain",
    value: function setGeneralStoreDomain(key, obj) {
      this.generalStore[key] = obj;
    }
  }, {
    key: "getGeneralStoreDomain",
    value: function getGeneralStoreDomain(key) {
      return this.generalStore[key];
    }
  }, {
    key: "setTkeyStoreDomain",
    value: function setTkeyStoreDomain(key, arr) {
      this.tkeyStore[key] = arr;
    }
  }, {
    key: "getTkeyStoreDomain",
    value: function getTkeyStoreDomain(key) {
      return this.tkeyStore[key];
    }
  }, {
    key: "addFromPolynomialAndShares",
    value: function addFromPolynomialAndShares(polynomial, shares) {
      var publicPolynomial = polynomial.getPublicPolynomial();
      this.addPublicPolynomial(publicPolynomial);

      if (Array.isArray(shares)) {
        for (var i = 0; i < shares.length; i += 1) {
          this.addPublicShare(publicPolynomial.getPolynomialID(), shares[i].getPublicShare());
        }
      } else {
        for (var k in shares) {
          if (Object.prototype.hasOwnProperty.call(shares, k)) {
            this.addPublicShare(publicPolynomial.getPolynomialID(), shares[k].getPublicShare());
          }
        }
      }
    }
  }, {
    key: "setScopedStore",
    value: function setScopedStore(domain, data) {
      this.scopedStore[domain] = data;
    }
  }, {
    key: "getEncryptedShare",
    value: function () {
      var _getEncryptedShare = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(shareStore) {
        var pubShare, encryptedShareStore, encryptedShare, rawDecrypted;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                pubShare = shareStore.share.getPublicShare();
                encryptedShareStore = this.scopedStore.encryptedShares;

                if (encryptedShareStore) {
                  _context.next = 4;
                  break;
                }

                throw errors.encryptedShareStoreUnavailable("".concat(shareStore));

              case 4:
                encryptedShare = encryptedShareStore[pubShare.shareCommitment.x.toString("hex")];

                if (encryptedShare) {
                  _context.next = 7;
                  break;
                }

                throw errors.encryptedShareStoreUnavailable("".concat(shareStore));

              case 7:
                _context.next = 9;
                return Object(common_types_["decrypt"])(Object(common_types_["toPrivKeyECC"])(shareStore.share.share), encryptedShare);

              case 9:
                rawDecrypted = _context.sent;
                return _context.abrupt("return", common_types_["ShareStore"].fromJSON(JSON.parse(rawDecrypted.toString())));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getEncryptedShare(_x) {
        return _getEncryptedShare.apply(this, arguments);
      }

      return getEncryptedShare;
    }()
  }, {
    key: "getShareDescription",
    value: function getShareDescription() {
      return this.getGeneralStoreDomain("shareDescriptions");
    }
  }, {
    key: "addShareDescription",
    value: function addShareDescription(shareIndex, description) {
      var currentSD = this.getGeneralStoreDomain("shareDescriptions") || {};

      if (currentSD[shareIndex]) {
        currentSD[shareIndex].push(description);
      } else {
        currentSD[shareIndex] = [description];
      }

      this.setGeneralStoreDomain("shareDescriptions", currentSD);
    }
  }, {
    key: "deleteShareDescription",
    value: function deleteShareDescription(shareIndex, description) {
      var currentSD = this.getGeneralStoreDomain("shareDescriptions");
      var index = currentSD[shareIndex].indexOf(description);

      if (index > -1) {
        currentSD[shareIndex].splice(index, 1);
      }
    }
  }, {
    key: "shareToShareStore",
    value: function shareToShareStore(share) {
      var _this = this;

      var pubkey = Object(common_types_["getPubKeyPoint"])(share);
      var returnShare;
      Object.keys(this.publicShares).forEach(function (el) {
        // eslint-disable-next-line consistent-return
        Object.keys(_this.publicShares[el]).forEach(function (pl) {
          var pubShare = _this.publicShares[el][pl];

          if (pubShare.shareCommitment.x.eq(pubkey.x) && pubShare.shareCommitment.y.eq(pubkey.y)) {
            var tempShare = new common_types_["Share"](pubShare.shareIndex, share);
            returnShare = new common_types_["ShareStore"](tempShare, el);
          }
        });
      });
      if (returnShare) return returnShare;
      throw errors["default"]("Share doesn't exist");
    }
  }, {
    key: "clone",
    value: function clone() {
      return Metadata.fromJSON(JSON.parse(external_json_stable_stringify_default()(this)));
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      // squash data to serialized polyID according to spec
      var serializedPolyIDList = [];

      for (var i = 0; i < this.polyIDList.length; i += 1) {
        var _polyID$split$concat;

        var polyID = this.polyIDList[i];
        var shareIndexes = Object.keys(this.publicShares[polyID]);
        var sortedShareIndexes = shareIndexes.sort(function (a, b) {
          return new external_bn_js_default.a(a, "hex").cmp(new external_bn_js_default.a(b, "hex"));
        });

        var serializedPolyID = (_polyID$split$concat = polyID.split("|").concat("0x0")).concat.apply(_polyID$split$concat, toConsumableArray_default()(sortedShareIndexes)).join("|");

        serializedPolyIDList.push(serializedPolyID);
      }

      return {
        pubKey: this.pubKey.encode("elliptic-compressed", {
          ec: common_types_["ecCurve"]
        }).toString(),
        polyIDList: serializedPolyIDList,
        scopedStore: this.scopedStore,
        generalStore: this.generalStore,
        tkeyStore: this.tkeyStore,
        nonce: this.nonce
      };
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(value) {
      var pubKey = value.pubKey,
          polyIDList = value.polyIDList,
          generalStore = value.generalStore,
          tkeyStore = value.tkeyStore,
          scopedStore = value.scopedStore,
          nonce = value.nonce;
      var point = common_types_["Point"].fromCompressedPub(pubKey);
      var metadata = new Metadata(point);
      var unserializedPolyIDList = [];
      if (generalStore) metadata.generalStore = generalStore;
      if (tkeyStore) metadata.tkeyStore = tkeyStore;
      if (scopedStore) metadata.scopedStore = scopedStore;
      if (nonce) metadata.nonce = nonce;

      var _loop = function _loop(i) {
        var serializedPolyID = polyIDList[i];
        var arrPolyID = serializedPolyID.split("|");
        var firstHalf = arrPolyID.slice(0, arrPolyID.findIndex(function (v) {
          return v === "0x0";
        }));
        var secondHalf = arrPolyID.slice(arrPolyID.findIndex(function (v) {
          return v === "0x0";
        }) + 1, arrPolyID.length); // for publicPolynomials

        var pubPolyID = firstHalf.join("|");
        var pointCommitments = [];
        firstHalf.forEach(function (compressedCommitment) {
          pointCommitments.push(common_types_["Point"].fromCompressedPub(compressedCommitment));
        });
        var publicPolynomial = new common_types_["PublicPolynomial"](pointCommitments);
        metadata.publicPolynomials[pubPolyID] = publicPolynomial; // for publicShares

        secondHalf.forEach(function (shareIndex) {
          var newPubShare = new common_types_["PublicShare"](shareIndex, polyCommitmentEval(publicPolynomial.polynomialCommitments, new external_bn_js_default.a(shareIndex, "hex")));
          metadata.addPublicShare(pubPolyID, newPubShare);
        }); // for polyIDList

        unserializedPolyIDList.push(pubPolyID);
      };

      for (var i = 0; i < polyIDList.length; i += 1) {
        _loop(i);
      }

      metadata.polyIDList = unserializedPolyIDList;
      return metadata;
    }
  }]);

  return Metadata;
}();

/* harmony default export */ var src_metadata = (metadata_Metadata);
// CONCATENATED MODULE: ./src/authMetadata.ts









var authMetadata_AuthMetadata = /*#__PURE__*/function () {
  function AuthMetadata(metadata, privKey) {
    classCallCheck_default()(this, AuthMetadata);

    defineProperty_default()(this, "metadata", void 0);

    defineProperty_default()(this, "privKey", void 0);

    this.metadata = metadata;
    this.privKey = privKey;
  }

  createClass_default()(AuthMetadata, [{
    key: "toJSON",
    value: function toJSON() {
      var data = this.metadata;
      var k = Object(common_types_["toPrivKeyEC"])(this.privKey);
      var sig = k.sign(Object(common_types_["stripHexPrefix"])(Object(external_web3_utils_["keccak256"])(external_json_stable_stringify_default()(data))));
      return {
        data: data,
        sig: sig.toDER("hex")
      };
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(value) {
      var data = value.data,
          sig = value.sig;
      var m = src_metadata.fromJSON(data);
      var pubK = common_types_["ecCurve"].keyFromPublic({
        x: m.pubKey.x.toString("hex", 64),
        y: m.pubKey.y.toString("hex", 64)
      }, "hex");

      if (!pubK.verify(Object(common_types_["stripHexPrefix"])(Object(external_web3_utils_["keccak256"])(external_json_stable_stringify_default()(data))), sig)) {
        throw errors["default"]("Signature not valid for returning metadata");
      }

      return new AuthMetadata(m);
    }
  }]);

  return AuthMetadata;
}();

/* harmony default export */ var src_authMetadata = (authMetadata_AuthMetadata);
// EXTERNAL MODULE: external "@babel/runtime/helpers/typeof"
var typeof_ = __webpack_require__(10);
var typeof_default = /*#__PURE__*/__webpack_require__.n(typeof_);

// CONCATENATED MODULE: ./src/core.ts














 // TODO: handle errors for get and set with retries

var core_ThresholdKey = /*#__PURE__*/function () {
  function ThresholdKey(args) {
    classCallCheck_default()(this, ThresholdKey);

    defineProperty_default()(this, "modules", void 0);

    defineProperty_default()(this, "enableLogging", void 0);

    defineProperty_default()(this, "serviceProvider", void 0);

    defineProperty_default()(this, "storageLayer", void 0);

    defineProperty_default()(this, "shares", void 0);

    defineProperty_default()(this, "privKey", void 0);

    defineProperty_default()(this, "metadata", void 0);

    defineProperty_default()(this, "refreshMiddleware", void 0);

    defineProperty_default()(this, "reconstructKeyMiddleware", void 0);

    defineProperty_default()(this, "shareSerializationMiddleware", void 0);

    defineProperty_default()(this, "storeDeviceShare", void 0);

    defineProperty_default()(this, "haveWriteMetadataLock", void 0);

    var _ref = args || {},
        _ref$enableLogging = _ref.enableLogging,
        enableLogging = _ref$enableLogging === void 0 ? false : _ref$enableLogging,
        _ref$modules = _ref.modules,
        modules = _ref$modules === void 0 ? {} : _ref$modules,
        serviceProvider = _ref.serviceProvider,
        storageLayer = _ref.storageLayer;

    this.enableLogging = enableLogging;
    this.serviceProvider = serviceProvider;
    this.storageLayer = storageLayer;
    this.modules = modules;
    this.shares = {};
    this.privKey = undefined;
    this.refreshMiddleware = {};
    this.reconstructKeyMiddleware = {};
    this.shareSerializationMiddleware = undefined;
    this.storeDeviceShare = undefined;
    this.setModuleReferences(); // Providing ITKeyApi access to modules

    this.haveWriteMetadataLock = "";
  }

  createClass_default()(ThresholdKey, [{
    key: "getApi",
    value: function getApi() {
      return {
        getMetadata: this.getMetadata.bind(this),
        updateMetadata: this.updateMetadata.bind(this),
        getStorageLayer: this.getStorageLayer.bind(this),
        initialize: this.initialize.bind(this),
        catchupToLatestShare: this.catchupToLatestShare.bind(this),
        syncShareMetadata: this.syncShareMetadata.bind(this),
        addRefreshMiddleware: this.addRefreshMiddleware.bind(this),
        addReconstructKeyMiddleware: this.addReconstructKeyMiddleware.bind(this),
        addShareSerializationMiddleware: this.addShareSerializationMiddleware.bind(this),
        addShareDescription: this.addShareDescription.bind(this),
        generateNewShare: this.generateNewShare.bind(this),
        inputShareStore: this.inputShareStore.bind(this),
        inputShareStoreSafe: this.inputShareStoreSafe.bind(this),
        outputShareStore: this.outputShareStore.bind(this),
        inputShare: this.inputShare.bind(this),
        outputShare: this.outputShare.bind(this),
        setDeviceStorage: this.setDeviceStorage.bind(this),
        encrypt: this.encrypt.bind(this),
        decrypt: this.decrypt.bind(this),
        getTKeyStore: this.getTKeyStore.bind(this),
        getTKeyStoreItem: this.getTKeyStoreItem.bind(this),
        setTKeyStoreItem: this.setTKeyStoreItem.bind(this),
        deleteTKeyStoreItem: this.deleteTKeyStoreItem.bind(this),
        deleteShare: this.deleteShare.bind(this)
      };
    }
  }, {
    key: "getStorageLayer",
    value: function getStorageLayer() {
      return this.storageLayer;
    }
  }, {
    key: "getMetadata",
    value: function getMetadata() {
      if (typeof this.metadata !== "undefined") {
        return this.metadata;
      }

      throw errors.metadataUndefined();
    }
  }, {
    key: "updateMetadata",
    value: function () {
      var _updateMetadata = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var shareIndexesExistInSDK, randomShareStore, latestShareDetails;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                shareIndexesExistInSDK = Object.keys(this.shares[this.metadata.getLatestPublicPolynomial().getPolynomialID()]);
                randomShareStore = this.outputShareStore(shareIndexesExistInSDK[Math.floor(Math.random() * (shareIndexesExistInSDK.length - 1))]);
                _context.next = 4;
                return this.catchupToLatestShare(randomShareStore);

              case 4:
                latestShareDetails = _context.sent;
                this.metadata = latestShareDetails.shareMetadata;
                _context.next = 8;
                return this.reconstructKey();

              case 8:
                return _context.abrupt("return", latestShareDetails.shareMetadata);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function updateMetadata() {
        return _updateMetadata.apply(this, arguments);
      }

      return updateMetadata;
    }()
  }, {
    key: "initialize",
    value: function () {
      var _initialize = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(params) {
        var p, input, importKey, neverInitializeNewKey, shareStore, rawServiceProviderShare, latestShareDetails;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                p = params || {};
                input = p.input, importKey = p.importKey, neverInitializeNewKey = p.neverInitializeNewKey;

                if (!(input instanceof common_types_["ShareStore"])) {
                  _context2.next = 6;
                  break;
                }

                shareStore = input;
                _context2.next = 24;
                break;

              case 6:
                if (!(typeof_default()(input) === "object")) {
                  _context2.next = 10;
                  break;
                }

                shareStore = common_types_["ShareStore"].fromJSON(input);
                _context2.next = 24;
                break;

              case 10:
                if (input) {
                  _context2.next = 23;
                  break;
                }

                _context2.next = 13;
                return this.storageLayer.getMetadata({
                  serviceProvider: this.serviceProvider
                });

              case 13:
                rawServiceProviderShare = _context2.sent;

                if (!(rawServiceProviderShare.message === common_types_["KEY_NOT_FOUND"])) {
                  _context2.next = 20;
                  break;
                }

                if (!neverInitializeNewKey) {
                  _context2.next = 17;
                  break;
                }

                throw errors["default"]("key has not yet been generated");

              case 17:
                _context2.next = 19;
                return this.initializeNewKey({
                  initializeModules: true,
                  importedKey: importKey
                });

              case 19:
                return _context2.abrupt("return", this.getKeyDetails());

              case 20:
                // else we continue with catching up share and metadata
                shareStore = common_types_["ShareStore"].fromJSON(rawServiceProviderShare);
                _context2.next = 24;
                break;

              case 23:
                throw errors["default"]("Input is not supported");

              case 24:
                _context2.next = 26;
                return this.catchupToLatestShare(shareStore);

              case 26:
                latestShareDetails = _context2.sent;
                this.metadata = latestShareDetails.shareMetadata;
                this.inputShareStore(latestShareDetails.latestShare); // now that we have metadata we set the requirements for reconstruction
                // initialize modules
                // this.setModuleReferences();

                _context2.next = 31;
                return this.initializeModules();

              case 31:
                return _context2.abrupt("return", this.getKeyDetails());

              case 32:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }

      return initialize;
    }()
  }, {
    key: "setModuleReferences",
    value: function setModuleReferences() {
      var _this = this;

      Object.keys(this.modules).map(function (x) {
        return _this.modules[x].setModuleReferences(_this.getApi());
      });
    }
  }, {
    key: "initializeModules",
    value: function () {
      var _initializeModules = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var _this2 = this;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", Promise.all(Object.keys(this.modules).map(function (x) {
                  return _this2.modules[x].initialize();
                })));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function initializeModules() {
        return _initializeModules.apply(this, arguments);
      }

      return initializeModules;
    }()
    /**
     * catchupToLatestShare recursively loops fetches metadata of the provided share and checks if there is an encrypted share for it.
     * @param shareStore share to start of with
     * @param polyID if specified, polyID to refresh to if it exists
     */

  }, {
    key: "catchupToLatestShare",
    value: function () {
      var _catchupToLatestShare = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4(shareStore, polyID) {
        var shareMetadata, nextShare;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return this.getAuthMetadata({
                  privKey: shareStore.share.share
                });

              case 3:
                shareMetadata = _context4.sent;
                _context4.next = 9;
                break;

              case 6:
                _context4.prev = 6;
                _context4.t0 = _context4["catch"](0);
                throw errors.metadataGetFailed("".concat(Object(common_types_["prettyPrintError"])(_context4.t0)));

              case 9:
                _context4.prev = 9;

                if (!polyID) {
                  _context4.next = 13;
                  break;
                }

                if (!(shareStore.polynomialID === polyID)) {
                  _context4.next = 13;
                  break;
                }

                return _context4.abrupt("return", {
                  latestShare: shareStore,
                  shareMetadata: shareMetadata
                });

              case 13:
                _context4.next = 15;
                return shareMetadata.getEncryptedShare(shareStore);

              case 15:
                nextShare = _context4.sent;
                return _context4.abrupt("return", this.catchupToLatestShare(nextShare));

              case 19:
                _context4.prev = 19;
                _context4.t1 = _context4["catch"](9);
                return _context4.abrupt("return", {
                  latestShare: shareStore,
                  shareMetadata: shareMetadata
                });

              case 22:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 6], [9, 19]]);
      }));

      function catchupToLatestShare(_x2, _x3) {
        return _catchupToLatestShare.apply(this, arguments);
      }

      return catchupToLatestShare;
    }()
  }, {
    key: "reconstructKey",
    value: function () {
      var _reconstructKey = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var _this3 = this;

        var reconstructKeyMiddleware,
            pubPoly,
            requiredThreshold,
            pubPolyID,
            sharesLeft,
            fullShareList,
            shareIndexesRequired,
            i,
            sharesToInput,
            z,
            sharesForPoly,
            shareIndexesForPoly,
            k,
            currentShareForPoly,
            latestShareRes,
            polyShares,
            shareArr,
            shareIndexArr,
            _i,
            privKey,
            reconstructedPubKey,
            returnObject,
            _args6 = arguments;

        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                reconstructKeyMiddleware = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : true;

                if (this.metadata) {
                  _context6.next = 3;
                  break;
                }

                throw errors.metadataUndefined();

              case 3:
                pubPoly = this.metadata.getLatestPublicPolynomial();
                requiredThreshold = pubPoly.getThreshold();
                pubPolyID = pubPoly.getPolynomialID(); // check if we have enough shares to meet threshold

                sharesLeft = requiredThreshold; // we don't just check the latest poly but
                //  we check if the shares on previous polynomials in our stores have the share indexes we require

                fullShareList = Object.keys(this.metadata.publicShares[pubPolyID]);
                shareIndexesRequired = {};

                for (i = 0; i < fullShareList.length; i += 1) {
                  shareIndexesRequired[fullShareList[i]] = true;
                }

                sharesToInput = [];
                z = this.metadata.polyIDList.length - 1;

              case 12:
                if (!(z >= 0 && sharesLeft > 0)) {
                  _context6.next = 40;
                  break;
                }

                sharesForPoly = this.shares[this.metadata.polyIDList[z]];

                if (!sharesForPoly) {
                  _context6.next = 37;
                  break;
                }

                shareIndexesForPoly = Object.keys(sharesForPoly);
                k = 0;

              case 17:
                if (!(k < shareIndexesForPoly.length && sharesLeft > 0)) {
                  _context6.next = 37;
                  break;
                }

                if (!(shareIndexesForPoly[k] in shareIndexesRequired)) {
                  _context6.next = 34;
                  break;
                }

                currentShareForPoly = sharesForPoly[shareIndexesForPoly[k]];

                if (!(currentShareForPoly.polynomialID === pubPolyID)) {
                  _context6.next = 24;
                  break;
                }

                sharesToInput.push(currentShareForPoly);
                _context6.next = 32;
                break;

              case 24:
                _context6.next = 26;
                return this.catchupToLatestShare(currentShareForPoly, pubPolyID);

              case 26:
                latestShareRes = _context6.sent;

                if (!(latestShareRes.latestShare.polynomialID === pubPolyID)) {
                  _context6.next = 31;
                  break;
                }

                sharesToInput.push(latestShareRes.latestShare);
                _context6.next = 32;
                break;

              case 31:
                throw new errors(1304, "Share found in unexpected polynomial");

              case 32:
                delete shareIndexesRequired[shareIndexesForPoly[k]];
                sharesLeft -= 1;

              case 34:
                k += 1;
                _context6.next = 17;
                break;

              case 37:
                z -= 1;
                _context6.next = 12;
                break;

              case 40:
                // Input shares to ensure atomicity
                sharesToInput.forEach(function (share) {
                  _this3.inputShareStore(share);
                });

                if (!(sharesLeft > 0)) {
                  _context6.next = 43;
                  break;
                }

                throw errors.unableToReconstruct(" require ".concat(requiredThreshold, " but have ").concat(sharesLeft - requiredThreshold));

              case 43:
                polyShares = Object.keys(this.shares[pubPolyID]);
                shareArr = [];
                shareIndexArr = [];

                for (_i = 0; _i < requiredThreshold; _i += 1) {
                  shareArr.push(this.shares[pubPolyID][polyShares[_i]].share.share);
                  shareIndexArr.push(this.shares[pubPolyID][polyShares[_i]].share.shareIndex);
                }

                privKey = lagrangeInterpolation(shareArr, shareIndexArr); // check that priv key regenerated is correct

                reconstructedPubKey = Object(common_types_["getPubKeyPoint"])(privKey);

                if (!(this.metadata.pubKey.x.cmp(reconstructedPubKey.x) !== 0)) {
                  _context6.next = 51;
                  break;
                }

                throw errors.incorrectReconstruction();

              case 51:
                this.setKey(privKey);
                returnObject = {
                  privKey: privKey,
                  allKeys: [privKey]
                };

                if (!(reconstructKeyMiddleware && Object.keys(this.reconstructKeyMiddleware).length > 0)) {
                  _context6.next = 56;
                  break;
                }

                _context6.next = 56;
                return Promise.all(Object.keys(this.reconstructKeyMiddleware).map( /*#__PURE__*/function () {
                  var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(x) {
                    var _returnObject$allKeys, extraKeys;

                    return regenerator_default.a.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            if (!Object.prototype.hasOwnProperty.call(_this3.reconstructKeyMiddleware, x)) {
                              _context5.next = 6;
                              break;
                            }

                            _context5.next = 3;
                            return _this3.reconstructKeyMiddleware[x]();

                          case 3:
                            extraKeys = _context5.sent;
                            returnObject[x] = extraKeys;

                            (_returnObject$allKeys = returnObject.allKeys).push.apply(_returnObject$allKeys, toConsumableArray_default()(extraKeys));

                          case 6:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5);
                  }));

                  return function (_x4) {
                    return _ref2.apply(this, arguments);
                  };
                }()));

              case 56:
                return _context6.abrupt("return", returnObject);

              case 57:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function reconstructKey() {
        return _reconstructKey.apply(this, arguments);
      }

      return reconstructKey;
    }()
  }, {
    key: "reconstructLatestPoly",
    value: function reconstructLatestPoly() {
      var pubPoly = this.metadata.getLatestPublicPolynomial();
      var pubPolyID = pubPoly.getPolynomialID();
      var threshold = pubPoly.getThreshold();
      var pointsArr = [];
      var sharesForExistingPoly = Object.keys(this.shares[pubPolyID]);

      if (sharesForExistingPoly.length < threshold) {
        throw errors.unableToReconstruct("not enough shares to reconstruct poly");
      }

      if (new Set(sharesForExistingPoly).size !== sharesForExistingPoly.length) {
        throw errors["default"]("share indexes should be unique");
      }

      for (var i = 0; i < threshold; i += 1) {
        pointsArr.push(new common_types_["Point"](new external_bn_js_default.a(sharesForExistingPoly[i], "hex"), this.shares[pubPolyID][sharesForExistingPoly[i]].share.share));
      }

      return lagrangeInterpolatePolynomial(pointsArr);
    }
  }, {
    key: "deleteShare",
    value: function () {
      var _deleteShare = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7(shareIndex) {
        var shareIndexToDelete, pubPoly, previousPolyID, existingShareIndexes, newShareIndexes, results, newShareStores;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (this.metadata) {
                  _context7.next = 2;
                  break;
                }

                throw errors.metadataUndefined();

              case 2:
                if (this.privKey) {
                  _context7.next = 4;
                  break;
                }

                throw errors.privateKeyUnavailable();

              case 4:
                shareIndexToDelete = new external_bn_js_default.a(shareIndex, "hex");

                if (!(shareIndexToDelete.cmp(new external_bn_js_default.a("1", "hex")) === 0)) {
                  _context7.next = 7;
                  break;
                }

                throw new errors(1001, "Unable to delete service provider share");

              case 7:
                // Get existing shares
                pubPoly = this.metadata.getLatestPublicPolynomial();
                previousPolyID = pubPoly.getPolynomialID();
                existingShareIndexes = this.metadata.getShareIndexesForPolynomial(previousPolyID);
                newShareIndexes = [];
                existingShareIndexes.forEach(function (el) {
                  var bn = new external_bn_js_default.a(el, "hex");

                  if (bn.cmp(shareIndexToDelete) !== 0) {
                    newShareIndexes.push(bn.toString("hex"));
                  }
                }); // Update shares

                if (!(existingShareIndexes.length === newShareIndexes.length)) {
                  _context7.next = 16;
                  break;
                }

                throw errors["default"]("Share index does not exist in latest polynomial");

              case 16:
                if (!(newShareIndexes.length < pubPoly.getThreshold())) {
                  _context7.next = 18;
                  break;
                }

                throw errors["default"]("Minimum ".concat(pubPoly.getThreshold(), " shares are required for tkey. Unable to delete share"));

              case 18:
                _context7.next = 20;
                return this.refreshShares(pubPoly.getThreshold(), [].concat(newShareIndexes), previousPolyID);

              case 20:
                results = _context7.sent;
                newShareStores = results.shareStores;
                return _context7.abrupt("return", {
                  newShareStores: newShareStores
                });

              case 23:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function deleteShare(_x5) {
        return _deleteShare.apply(this, arguments);
      }

      return deleteShare;
    }()
  }, {
    key: "generateNewShare",
    value: function () {
      var _generateNewShare = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
        var pubPoly, previousPolyID, existingShareIndexes, existingShareIndexesBN, newShareIndex, results, newShareStores;
        return regenerator_default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (this.metadata) {
                  _context8.next = 2;
                  break;
                }

                throw errors.metadataUndefined();

              case 2:
                if (this.privKey) {
                  _context8.next = 4;
                  break;
                }

                throw errors.privateKeyUnavailable();

              case 4:
                pubPoly = this.metadata.getLatestPublicPolynomial();
                previousPolyID = pubPoly.getPolynomialID();
                existingShareIndexes = this.metadata.getShareIndexesForPolynomial(previousPolyID);
                existingShareIndexesBN = existingShareIndexes.map(function (el) {
                  return new external_bn_js_default.a(el, "hex");
                });
                newShareIndex = new external_bn_js_default.a(Object(common_types_["generatePrivateExcludingIndexes"])(existingShareIndexesBN));
                _context8.next = 11;
                return this.refreshShares(pubPoly.getThreshold(), [].concat(toConsumableArray_default()(existingShareIndexes), [newShareIndex.toString("hex")]), previousPolyID);

              case 11:
                results = _context8.sent;
                newShareStores = results.shareStores;
                return _context8.abrupt("return", {
                  newShareStores: newShareStores,
                  newShareIndex: newShareIndex
                });

              case 14:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function generateNewShare() {
        return _generateNewShare.apply(this, arguments);
      }

      return generateNewShare;
    }()
  }, {
    key: "refreshShares",
    value: function () {
      var _refreshShares = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10(threshold, newShareIndexes, previousPolyID) {
        var _this4 = this;

        var poly, shares, existingShareIndexes, pointsArr, sharesForExistingPoly, i, oldPoly, shareIndexesNeedingEncryption, index, shareIndexHex, oldShareStores, newShareStores, polyID, m, newScopedStore, sharesToPush, metadataToPush, moduleName, adjustedGeneralStore, newShareMetadataToPush, newShareStoreSharesToPush, AuthMetadatas, _index, shareIndex;

        return regenerator_default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!(threshold > newShareIndexes.length)) {
                  _context10.next = 2;
                  break;
                }

                throw errors["default"]("threshold should not be greater than share indexes. ".concat(threshold, " > ").concat(newShareIndexes.length));

              case 2:
                _context10.next = 4;
                return this.acquireWriteMetadataLock();

              case 4:
                poly = generateRandomPolynomial(threshold - 1, this.privKey);
                shares = poly.generateShares(newShareIndexes);
                existingShareIndexes = this.metadata.getShareIndexesForPolynomial(previousPolyID);
                pointsArr = [];
                sharesForExistingPoly = Object.keys(this.shares[previousPolyID]);

                if (!(sharesForExistingPoly.length < threshold)) {
                  _context10.next = 11;
                  break;
                }

                throw errors.unableToReconstruct("not enough shares for polynomial reconstruction");

              case 11:
                for (i = 0; i < threshold; i += 1) {
                  pointsArr.push(new common_types_["Point"](new external_bn_js_default.a(sharesForExistingPoly[i], "hex"), this.shares[previousPolyID][sharesForExistingPoly[i]].share.share));
                }

                oldPoly = lagrangeInterpolatePolynomial(pointsArr);
                shareIndexesNeedingEncryption = [];

                for (index = 0; index < existingShareIndexes.length; index += 1) {
                  shareIndexHex = existingShareIndexes[index]; // define shares that need encryption/relaying

                  if (newShareIndexes.includes(shareIndexHex)) {
                    shareIndexesNeedingEncryption.push(shareIndexHex);
                  }
                } // add metadata new poly to metadata


                this.metadata.addFromPolynomialAndShares(poly, shares); // change to share stores for public storing

                oldShareStores = {};
                newShareStores = {};
                polyID = poly.getPolynomialID();
                newShareIndexes.forEach(function (shareIndexHex) {
                  newShareStores[shareIndexHex] = new common_types_["ShareStore"](shares[shareIndexHex], polyID);
                }); // evaluate oldPoly for old shares and set new metadata with encrypted share for new polynomial

                m = this.metadata.clone();
                newScopedStore = {};
                _context10.next = 24;
                return Promise.all(shareIndexesNeedingEncryption.map( /*#__PURE__*/function () {
                  var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9(shareIndex) {
                    var oldShare, encryptedShare;
                    return regenerator_default.a.wrap(function _callee9$(_context9) {
                      while (1) {
                        switch (_context9.prev = _context9.next) {
                          case 0:
                            oldShare = oldPoly.polyEval(new external_bn_js_default.a(shareIndex, "hex"));
                            _context9.next = 3;
                            return Object(common_types_["encrypt"])(Object(common_types_["getPubKeyECC"])(oldShare), Buffer.from(JSON.stringify(newShareStores[shareIndex])));

                          case 3:
                            encryptedShare = _context9.sent;
                            newScopedStore[Object(common_types_["getPubKeyPoint"])(oldShare).x.toString("hex")] = encryptedShare;
                            oldShareStores[shareIndex] = new common_types_["ShareStore"](new common_types_["Share"](shareIndex, oldShare), previousPolyID);
                            return _context9.abrupt("return", oldShare);

                          case 7:
                          case "end":
                            return _context9.stop();
                        }
                      }
                    }, _callee9);
                  }));

                  return function (_x9) {
                    return _ref3.apply(this, arguments);
                  };
                }()));

              case 24:
                sharesToPush = _context10.sent;
                m.setScopedStore("encryptedShares", newScopedStore);
                metadataToPush = Array(sharesToPush.length).fill(m); // run refreshShare middleware

                for (moduleName in this.refreshMiddleware) {
                  if (Object.prototype.hasOwnProperty.call(this.refreshMiddleware, moduleName)) {
                    adjustedGeneralStore = this.refreshMiddleware[moduleName](this.metadata.getGeneralStoreDomain(moduleName), oldShareStores, newShareStores);
                    this.metadata.setGeneralStoreDomain(moduleName, adjustedGeneralStore);
                  }
                }

                newShareMetadataToPush = [];
                newShareStoreSharesToPush = newShareIndexes.map(function (shareIndex) {
                  var me = _this4.metadata.clone();

                  newShareMetadataToPush.push(me);
                  return newShareStores[shareIndex].share.share;
                });
                AuthMetadatas = this.generateAuthMetadata({
                  input: [].concat(toConsumableArray_default()(metadataToPush), newShareMetadataToPush)
                }); // Combine Authmetadata and service provider ShareStore

                _context10.next = 33;
                return this.storageLayer.setMetadataStream({
                  input: [].concat(toConsumableArray_default()(AuthMetadatas), [newShareStores["1"]]),
                  privKey: [].concat(toConsumableArray_default()(sharesToPush), toConsumableArray_default()(newShareStoreSharesToPush), [undefined]),
                  serviceProvider: this.serviceProvider
                });

              case 33:
                // set metadata for all new shares
                for (_index = 0; _index < newShareIndexes.length; _index += 1) {
                  shareIndex = newShareIndexes[_index];
                  this.inputShareStore(newShareStores[shareIndex]);
                }

                _context10.next = 36;
                return this.releaseWriteMetadataLock();

              case 36:
                return _context10.abrupt("return", {
                  shareStores: newShareStores
                });

              case 37:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function refreshShares(_x6, _x7, _x8) {
        return _refreshShares.apply(this, arguments);
      }

      return refreshShares;
    }()
  }, {
    key: "initializeNewKey",
    value: function () {
      var _initializeNewKey = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee11() {
        var _ref4,
            determinedShare,
            initializeModules,
            importedKey,
            tmpPriv,
            shareIndexForDeviceStorage,
            shareIndexes,
            poly,
            shareIndexForDeterminedShare,
            shares,
            metadata,
            serviceProviderShare,
            shareStore,
            metadataToPush,
            sharesToPush,
            authMetadatas,
            index,
            shareIndex,
            result,
            _args11 = arguments;

        return regenerator_default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _ref4 = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : {}, determinedShare = _ref4.determinedShare, initializeModules = _ref4.initializeModules, importedKey = _ref4.importedKey;

                if (!importedKey) {
                  tmpPriv = Object(eccrypto_["generatePrivate"])();
                  this.setKey(new external_bn_js_default.a(tmpPriv));
                } else {
                  this.setKey(new external_bn_js_default.a(importedKey));
                } // create a random poly and respective shares
                // 1 is defined as the serviceProvider share
                // 0 is for tKey


                shareIndexForDeviceStorage = Object(common_types_["generatePrivateExcludingIndexes"])([new external_bn_js_default.a(1), new external_bn_js_default.a(0)]);
                shareIndexes = [new external_bn_js_default.a(1), shareIndexForDeviceStorage];

                if (determinedShare) {
                  shareIndexForDeterminedShare = Object(common_types_["generatePrivateExcludingIndexes"])([new external_bn_js_default.a(1), new external_bn_js_default.a(0)]);
                  poly = generateRandomPolynomial(1, this.privKey, [new common_types_["Share"](shareIndexForDeterminedShare, determinedShare)]);
                  shareIndexes.push(shareIndexForDeterminedShare);
                } else {
                  poly = generateRandomPolynomial(1, this.privKey);
                }

                shares = poly.generateShares(shareIndexes); // create metadata to be stored

                metadata = new src_metadata(Object(common_types_["getPubKeyPoint"])(this.privKey));
                metadata.addFromPolynomialAndShares(poly, shares);
                serviceProviderShare = shares[shareIndexes[0].toString("hex")];
                shareStore = new common_types_["ShareStore"](serviceProviderShare, poly.getPolynomialID());
                metadataToPush = [];
                sharesToPush = shareIndexes.map(function (shareIndex) {
                  metadataToPush.push(metadata);
                  return shares[shareIndex.toString("hex")].share;
                });
                authMetadatas = this.generateAuthMetadata({
                  input: metadataToPush
                }); // because this is the first time we're setting metadata there is no need to acquire a lock

                _context11.next = 15;
                return this.storageLayer.setMetadataStream({
                  input: [].concat(toConsumableArray_default()(authMetadatas), [shareStore]),
                  privKey: [].concat(toConsumableArray_default()(sharesToPush), [undefined]),
                  serviceProvider: this.serviceProvider
                });

              case 15:
                // store metadata on metadata respective to shares
                for (index = 0; index < shareIndexes.length; index += 1) {
                  shareIndex = shareIndexes[index]; // also add into our share store

                  this.inputShareStore(new common_types_["ShareStore"](shares[shareIndex.toString("hex")], poly.getPolynomialID()));
                }

                this.metadata = metadata; // initialize modules

                if (!initializeModules) {
                  _context11.next = 20;
                  break;
                }

                _context11.next = 20;
                return this.initializeModules();

              case 20:
                if (!this.storeDeviceShare) {
                  _context11.next = 23;
                  break;
                }

                _context11.next = 23;
                return this.storeDeviceShare(new common_types_["ShareStore"](shares[shareIndexes[1].toString("hex")], poly.getPolynomialID()));

              case 23:
                result = {
                  privKey: this.privKey,
                  deviceShare: new common_types_["ShareStore"](shares[shareIndexes[1].toString("hex")], poly.getPolynomialID()),
                  userShare: undefined
                };

                if (determinedShare) {
                  result.userShare = new common_types_["ShareStore"](shares[shareIndexes[2].toString("hex")], poly.getPolynomialID());
                }

                return _context11.abrupt("return", result);

              case 26:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function initializeNewKey() {
        return _initializeNewKey.apply(this, arguments);
      }

      return initializeNewKey;
    }()
  }, {
    key: "inputShareStore",
    value: function inputShareStore(shareStore) {
      var ss;

      if (shareStore instanceof common_types_["ShareStore"]) {
        ss = shareStore;
      } else if (typeof_default()(shareStore) === "object") {
        ss = common_types_["ShareStore"].fromJSON(shareStore);
      } else {
        throw errors["default"]("can only add type ShareStore into shares");
      }

      if (!(ss.polynomialID in this.shares)) {
        this.shares[ss.polynomialID] = {};
      }

      this.shares[ss.polynomialID][ss.share.shareIndex.toString("hex")] = ss;
    } // inputs a share ensuring that the share is the latest share AND metadata is updated to its latest state

  }, {
    key: "inputShareStoreSafe",
    value: function () {
      var _inputShareStoreSafe = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee12(shareStore) {
        var ss, latestShareRes;
        return regenerator_default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (!(shareStore instanceof common_types_["ShareStore"])) {
                  _context12.next = 4;
                  break;
                }

                ss = shareStore;
                _context12.next = 9;
                break;

              case 4:
                if (!(typeof_default()(shareStore) === "object")) {
                  _context12.next = 8;
                  break;
                }

                ss = common_types_["ShareStore"].fromJSON(shareStore);
                _context12.next = 9;
                break;

              case 8:
                throw errors["default"]("can only add type ShareStore into shares");

              case 9:
                _context12.next = 11;
                return this.catchupToLatestShare(ss);

              case 11:
                latestShareRes = _context12.sent;

                // if not in poly id list, metadata is probably outdated
                if (!this.metadata.polyIDList.includes(latestShareRes.latestShare.polynomialID)) {
                  this.metadata = latestShareRes.shareMetadata;
                }

                if (!(latestShareRes.latestShare.polynomialID in this.shares)) {
                  this.shares[latestShareRes.latestShare.polynomialID] = {};
                }

                this.shares[latestShareRes.latestShare.polynomialID][latestShareRes.latestShare.share.shareIndex.toString("hex")] = latestShareRes.latestShare;

              case 15:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function inputShareStoreSafe(_x10) {
        return _inputShareStoreSafe.apply(this, arguments);
      }

      return inputShareStoreSafe;
    }()
  }, {
    key: "outputShareStore",
    value: function outputShareStore(shareIndex) {
      var shareIndexParsed;

      if (typeof shareIndex === "number") {
        shareIndexParsed = new external_bn_js_default.a(shareIndex);
      } else if (external_bn_js_default.a.isBN(shareIndex)) {
        shareIndexParsed = shareIndex;
      } else if (typeof shareIndex === "string") {
        shareIndexParsed = new external_bn_js_default.a(shareIndex, "hex");
      }

      var latestPolyID = this.metadata.getLatestPublicPolynomial().getPolynomialID();

      if (!this.metadata.publicShares[latestPolyID][shareIndexParsed.toString("hex")]) {
        throw new errors(1002, "no such share index created");
      }

      var shareFromStore = this.shares[latestPolyID][shareIndexParsed.toString("hex")];
      if (shareFromStore) return shareFromStore;
      var poly = this.reconstructLatestPoly();
      var shareMap = poly.generateShares([shareIndexParsed]);
      return new common_types_["ShareStore"](shareMap[shareIndexParsed.toString("hex")], latestPolyID);
    }
  }, {
    key: "setKey",
    value: function setKey(privKey) {
      this.privKey = privKey;
    }
  }, {
    key: "getKey",
    value: function getKey() {
      return [this.privKey];
    }
  }, {
    key: "getCurrentShareIndexes",
    value: function getCurrentShareIndexes() {
      var latestPolynomial = this.metadata.getLatestPublicPolynomial();
      var latestPolynomialId = latestPolynomial.getPolynomialID();
      var currentShareIndexes = Object.keys(this.shares[latestPolynomialId]);
      return currentShareIndexes;
    }
  }, {
    key: "getKeyDetails",
    value: function getKeyDetails() {
      var poly = this.metadata.getLatestPublicPolynomial();
      var previousPolyID = poly.getPolynomialID();
      var requiredShares = poly.getThreshold() - Object.keys(this.shares[previousPolyID]).length;
      var shareDescriptions = this.metadata.getShareDescription();

      if (shareDescriptions) {
        var existingShareIndexes = this.metadata.getShareIndexesForPolynomial(previousPolyID);
        shareDescriptions = Object.keys(shareDescriptions).reduce(function (acc, index) {
          if (existingShareIndexes.indexOf(index) >= 0) acc[index] = shareDescriptions[index];
          return acc;
        }, {});
      }

      return {
        pubKey: this.metadata.pubKey,
        requiredShares: requiredShares,
        threshold: poly.getThreshold(),
        totalShares: Object.keys(this.metadata.publicShares[previousPolyID]).length,
        shareDescriptions: shareDescriptions
      };
    } // Auth functions

  }, {
    key: "generateAuthMetadata",
    value: function generateAuthMetadata(params) {
      var input = params.input;
      var authMetadatas = [];

      for (var i = 0; i < input.length; i += 1) {
        authMetadatas.push(new src_authMetadata(input[i], this.privKey));
      }

      return authMetadatas;
    }
  }, {
    key: "setAuthMetadata",
    value: function () {
      var _setAuthMetadata = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee13(params) {
        var input, serviceProvider, privKey, authMetadata;
        return regenerator_default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                input = params.input, serviceProvider = params.serviceProvider, privKey = params.privKey;
                authMetadata = new src_authMetadata(input, this.privKey);
                return _context13.abrupt("return", this.storageLayer.setMetadata({
                  input: authMetadata,
                  serviceProvider: serviceProvider,
                  privKey: privKey
                }));

              case 3:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function setAuthMetadata(_x11) {
        return _setAuthMetadata.apply(this, arguments);
      }

      return setAuthMetadata;
    }()
  }, {
    key: "setAuthMetadataBulk",
    value: function () {
      var _setAuthMetadataBulk = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee14(params) {
        var input, serviceProvider, privKey, authMetadatas, i;
        return regenerator_default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                input = params.input, serviceProvider = params.serviceProvider, privKey = params.privKey;
                authMetadatas = [];

                for (i = 0; i < input.length; i += 1) {
                  authMetadatas.push(new src_authMetadata(input[i], this.privKey));
                }

                return _context14.abrupt("return", this.storageLayer.setMetadataStream({
                  input: authMetadatas,
                  serviceProvider: serviceProvider,
                  privKey: privKey
                }));

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function setAuthMetadataBulk(_x12) {
        return _setAuthMetadataBulk.apply(this, arguments);
      }

      return setAuthMetadataBulk;
    }()
  }, {
    key: "getAuthMetadata",
    value: function () {
      var _getAuthMetadata = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee15(params) {
        var raw, authMetadata;
        return regenerator_default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this.storageLayer.getMetadata(params);

              case 2:
                raw = _context15.sent;
                authMetadata = src_authMetadata.fromJSON(raw);
                return _context15.abrupt("return", authMetadata.metadata);

              case 5:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function getAuthMetadata(_x13) {
        return _getAuthMetadata.apply(this, arguments);
      }

      return getAuthMetadata;
    }()
  }, {
    key: "acquireWriteMetadataLock",
    value: function () {
      var _acquireWriteMetadataLock = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee16() {
        var shareIndexesExistInSDK, randomShare, latestMetadata, res;
        return regenerator_default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                if (!this.haveWriteMetadataLock) {
                  _context16.next = 2;
                  break;
                }

                return _context16.abrupt("return", this.metadata.nonce);

              case 2:
                if (this.privKey) {
                  _context16.next = 4;
                  break;
                }

                throw errors.privateKeyUnavailable();

              case 4:
                // we check the metadata of a random share on the latest polynomial we have
                shareIndexesExistInSDK = Object.keys(this.shares[this.metadata.getLatestPublicPolynomial().getPolynomialID()]);
                randomShare = this.outputShareStore(shareIndexesExistInSDK[Math.floor(Math.random() * (shareIndexesExistInSDK.length - 1))]).share.share;
                _context16.next = 8;
                return this.getAuthMetadata({
                  privKey: randomShare
                });

              case 8:
                latestMetadata = _context16.sent;

                if (!(latestMetadata.nonce > this.metadata.nonce)) {
                  _context16.next = 11;
                  break;
                }

                throw errors.acquireLockFailed("unable to acquire write access for metadata due to local nonce (".concat(this.metadata.nonce, ")\n           being lower than last written metadata nonce (").concat(latestMetadata.nonce, "). perhaps update metadata SDK (create new tKey and init)"));

              case 11:
                _context16.next = 13;
                return this.storageLayer.acquireWriteLock({
                  privKey: this.privKey
                });

              case 13:
                res = _context16.sent;

                if (!(res.status !== 1)) {
                  _context16.next = 16;
                  break;
                }

                throw errors.acquireLockFailed("lock cannot be acquired from storage layer status code: ".concat(res.status));

              case 16:
                // increment metadata nonce for write session
                this.metadata.nonce += 1;
                this.haveWriteMetadataLock = res.id;
                return _context16.abrupt("return", this.metadata.nonce);

              case 19:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function acquireWriteMetadataLock() {
        return _acquireWriteMetadataLock.apply(this, arguments);
      }

      return acquireWriteMetadataLock;
    }()
  }, {
    key: "releaseWriteMetadataLock",
    value: function () {
      var _releaseWriteMetadataLock = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee17() {
        var res;
        return regenerator_default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                if (this.haveWriteMetadataLock) {
                  _context17.next = 2;
                  break;
                }

                throw errors.releaseLockFailed("releaseWriteMetadataLock - don't have metadata lock to release");

              case 2:
                _context17.next = 4;
                return this.storageLayer.releaseWriteLock({
                  privKey: this.privKey,
                  id: this.haveWriteMetadataLock
                });

              case 4:
                res = _context17.sent;

                if (!(res.status !== 1)) {
                  _context17.next = 7;
                  break;
                }

                throw errors.releaseLockFailed("lock cannot be released from storage layer status code: ".concat(res.status));

              case 7:
                this.haveWriteMetadataLock = "";

              case 8:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function releaseWriteMetadataLock() {
        return _releaseWriteMetadataLock.apply(this, arguments);
      }

      return releaseWriteMetadataLock;
    }() // Module functions

  }, {
    key: "syncShareMetadata",
    value: function () {
      var _syncShareMetadata = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee18(adjustScopedStore) {
        var pubPoly, pubPolyID, existingShareIndexes, threshold, pointsArr, sharesForExistingPoly, i, currentPoly, allExistingShares, shareArray;
        return regenerator_default.a.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                pubPoly = this.metadata.getLatestPublicPolynomial();
                pubPolyID = pubPoly.getPolynomialID();
                existingShareIndexes = this.metadata.getShareIndexesForPolynomial(pubPolyID);
                threshold = pubPoly.getThreshold();
                pointsArr = [];
                sharesForExistingPoly = Object.keys(this.shares[pubPolyID]);

                if (!(sharesForExistingPoly.length < threshold)) {
                  _context18.next = 8;
                  break;
                }

                throw errors.unableToReconstruct("not enough shares for polynomial reconstruction");

              case 8:
                for (i = 0; i < threshold; i += 1) {
                  pointsArr.push(new common_types_["Point"](new external_bn_js_default.a(sharesForExistingPoly[i], "hex"), this.shares[pubPolyID][sharesForExistingPoly[i]].share.share));
                }

                currentPoly = lagrangeInterpolatePolynomial(pointsArr);
                allExistingShares = currentPoly.generateShares(existingShareIndexes);
                shareArray = existingShareIndexes.map(function (shareIndex) {
                  return allExistingShares[shareIndex].share;
                });
                _context18.next = 14;
                return this.syncMultipleShareMetadata(shareArray, adjustScopedStore);

              case 14:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function syncShareMetadata(_x14) {
        return _syncShareMetadata.apply(this, arguments);
      }

      return syncShareMetadata;
    }()
  }, {
    key: "syncMultipleShareMetadata",
    value: function () {
      var _syncMultipleShareMetadata = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee20(shares, adjustScopedStore) {
        var _this5 = this;

        var newMetadataPromise, newMetadata;
        return regenerator_default.a.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.next = 2;
                return this.acquireWriteMetadataLock();

              case 2:
                newMetadataPromise = shares.map( /*#__PURE__*/function () {
                  var _ref5 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee19(share) {
                    var newMetadata, specificShareMetadata, scopedStoreToBeSet;
                    return regenerator_default.a.wrap(function _callee19$(_context19) {
                      while (1) {
                        switch (_context19.prev = _context19.next) {
                          case 0:
                            newMetadata = _this5.metadata.clone();
                            _context19.prev = 1;
                            _context19.next = 4;
                            return _this5.getAuthMetadata({
                              privKey: share
                            });

                          case 4:
                            specificShareMetadata = _context19.sent;
                            _context19.next = 10;
                            break;

                          case 7:
                            _context19.prev = 7;
                            _context19.t0 = _context19["catch"](1);
                            throw errors.metadataGetFailed("".concat(Object(common_types_["prettyPrintError"])(_context19.t0)));

                          case 10:
                            if (adjustScopedStore) {
                              scopedStoreToBeSet = adjustScopedStore(specificShareMetadata.scopedStore);
                            } else {
                              scopedStoreToBeSet = specificShareMetadata.scopedStore;
                            }

                            newMetadata.scopedStore = scopedStoreToBeSet;
                            return _context19.abrupt("return", newMetadata);

                          case 13:
                          case "end":
                            return _context19.stop();
                        }
                      }
                    }, _callee19, null, [[1, 7]]);
                  }));

                  return function (_x17) {
                    return _ref5.apply(this, arguments);
                  };
                }());
                _context20.next = 5;
                return Promise.all(newMetadataPromise);

              case 5:
                newMetadata = _context20.sent;
                _context20.next = 8;
                return this.setAuthMetadataBulk({
                  input: newMetadata,
                  privKey: shares
                });

              case 8:
                _context20.next = 10;
                return this.releaseWriteMetadataLock();

              case 10:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function syncMultipleShareMetadata(_x15, _x16) {
        return _syncMultipleShareMetadata.apply(this, arguments);
      }

      return syncMultipleShareMetadata;
    }()
  }, {
    key: "addRefreshMiddleware",
    value: function addRefreshMiddleware(moduleName, middleware) {
      this.refreshMiddleware[moduleName] = middleware;
    }
  }, {
    key: "addReconstructKeyMiddleware",
    value: function addReconstructKeyMiddleware(moduleName, middleware) {
      this.reconstructKeyMiddleware[moduleName] = middleware;
    }
  }, {
    key: "addShareSerializationMiddleware",
    value: function addShareSerializationMiddleware(serialize, deserialize) {
      this.shareSerializationMiddleware = {
        serialize: serialize,
        deserialize: deserialize
      };
    }
  }, {
    key: "setDeviceStorage",
    value: function setDeviceStorage(storeDeviceStorage) {
      if (this.storeDeviceShare) {
        throw errors["default"]("storeDeviceShare already set");
      }

      this.storeDeviceShare = storeDeviceStorage;
    }
  }, {
    key: "addShareDescription",
    value: function () {
      var _addShareDescription = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee21(shareIndex, description, updateMetadata) {
        return regenerator_default.a.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                this.metadata.addShareDescription(shareIndex, description);

                if (!updateMetadata) {
                  _context21.next = 4;
                  break;
                }

                _context21.next = 4;
                return this.syncShareMetadata();

              case 4:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function addShareDescription(_x18, _x19, _x20) {
        return _addShareDescription.apply(this, arguments);
      }

      return addShareDescription;
    }()
  }, {
    key: "deleteShareDescription",
    value: function () {
      var _deleteShareDescription = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee22(shareIndex, description, updateMetadata) {
        return regenerator_default.a.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                this.metadata.deleteShareDescription(shareIndex, description);

                if (!updateMetadata) {
                  _context22.next = 4;
                  break;
                }

                _context22.next = 4;
                return this.syncShareMetadata();

              case 4:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function deleteShareDescription(_x21, _x22, _x23) {
        return _deleteShareDescription.apply(this, arguments);
      }

      return deleteShareDescription;
    }()
  }, {
    key: "encrypt",
    value: function () {
      var _encrypt2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee23(data) {
        return regenerator_default.a.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                if (this.privKey) {
                  _context23.next = 2;
                  break;
                }

                throw errors.privateKeyUnavailable();

              case 2:
                return _context23.abrupt("return", Object(common_types_["encrypt"])(Object(common_types_["getPubKeyECC"])(this.privKey), data));

              case 3:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function encrypt(_x24) {
        return _encrypt2.apply(this, arguments);
      }

      return encrypt;
    }()
  }, {
    key: "decrypt",
    value: function () {
      var _decrypt2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee24(encryptedMessage) {
        return regenerator_default.a.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                if (this.privKey) {
                  _context24.next = 2;
                  break;
                }

                throw errors.privateKeyUnavailable();

              case 2:
                return _context24.abrupt("return", Object(common_types_["decrypt"])(Object(common_types_["toPrivKeyECC"])(this.privKey), encryptedMessage));

              case 3:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function decrypt(_x25) {
        return _decrypt2.apply(this, arguments);
      }

      return decrypt;
    }()
  }, {
    key: "setTKeyStoreItem",
    value: function () {
      var _setTKeyStoreItem = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee26(moduleName, data, updateMetadata) {
        var _this6 = this;

        var rawTkeyStoreItems, decryptedItems, encryptedData, duplicateItemIndex;
        return regenerator_default.a.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                rawTkeyStoreItems = this.metadata.getTkeyStoreDomain(moduleName) || [];
                _context26.next = 3;
                return Promise.all(rawTkeyStoreItems.map( /*#__PURE__*/function () {
                  var _ref6 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee25(x) {
                    var decryptedItem;
                    return regenerator_default.a.wrap(function _callee25$(_context25) {
                      while (1) {
                        switch (_context25.prev = _context25.next) {
                          case 0:
                            _context25.next = 2;
                            return _this6.decrypt(x);

                          case 2:
                            decryptedItem = _context25.sent;
                            return _context25.abrupt("return", JSON.parse(decryptedItem.toString()));

                          case 4:
                          case "end":
                            return _context25.stop();
                        }
                      }
                    }, _callee25);
                  }));

                  return function (_x29) {
                    return _ref6.apply(this, arguments);
                  };
                }()));

              case 3:
                decryptedItems = _context26.sent;
                _context26.next = 6;
                return this.encrypt(Buffer.from(external_json_stable_stringify_default()(data)));

              case 6:
                encryptedData = _context26.sent;
                duplicateItemIndex = decryptedItems.findIndex(function (x) {
                  return x.id === data.id;
                });

                if (duplicateItemIndex > -1) {
                  rawTkeyStoreItems[duplicateItemIndex] = encryptedData;
                } else {
                  rawTkeyStoreItems.push(encryptedData);
                } // update metadataStore


                this.metadata.setTkeyStoreDomain(moduleName, rawTkeyStoreItems);

                if (!updateMetadata) {
                  _context26.next = 13;
                  break;
                }

                _context26.next = 13;
                return this.syncShareMetadata();

              case 13:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function setTKeyStoreItem(_x26, _x27, _x28) {
        return _setTKeyStoreItem.apply(this, arguments);
      }

      return setTKeyStoreItem;
    }()
  }, {
    key: "deleteTKeyStoreItem",
    value: function () {
      var _deleteTKeyStoreItem = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee28(moduleName, id) {
        var _this7 = this;

        var rawTkeyStoreItems, decryptedItems, finalItems;
        return regenerator_default.a.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                rawTkeyStoreItems = this.metadata.getTkeyStoreDomain(moduleName) || [];
                _context28.next = 3;
                return Promise.all(rawTkeyStoreItems.map( /*#__PURE__*/function () {
                  var _ref7 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee27(x) {
                    var decryptedItem;
                    return regenerator_default.a.wrap(function _callee27$(_context27) {
                      while (1) {
                        switch (_context27.prev = _context27.next) {
                          case 0:
                            _context27.next = 2;
                            return _this7.decrypt(x);

                          case 2:
                            decryptedItem = _context27.sent;
                            return _context27.abrupt("return", JSON.parse(decryptedItem.toString()));

                          case 4:
                          case "end":
                            return _context27.stop();
                        }
                      }
                    }, _callee27);
                  }));

                  return function (_x32) {
                    return _ref7.apply(this, arguments);
                  };
                }()));

              case 3:
                decryptedItems = _context28.sent;
                finalItems = decryptedItems.filter(function (x) {
                  return x.id !== id;
                });
                this.metadata.setTkeyStoreDomain(moduleName, finalItems);
                _context28.next = 8;
                return this.syncShareMetadata();

              case 8:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function deleteTKeyStoreItem(_x30, _x31) {
        return _deleteTKeyStoreItem.apply(this, arguments);
      }

      return deleteTKeyStoreItem;
    }()
  }, {
    key: "getTKeyStore",
    value: function () {
      var _getTKeyStore = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee30(moduleName) {
        var _this8 = this;

        var rawTkeyStoreItems, decryptedItems;
        return regenerator_default.a.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                rawTkeyStoreItems = this.metadata.getTkeyStoreDomain(moduleName) || [];
                _context30.next = 3;
                return Promise.all(rawTkeyStoreItems.map( /*#__PURE__*/function () {
                  var _ref8 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee29(x) {
                    var decryptedItem;
                    return regenerator_default.a.wrap(function _callee29$(_context29) {
                      while (1) {
                        switch (_context29.prev = _context29.next) {
                          case 0:
                            _context29.next = 2;
                            return _this8.decrypt(x);

                          case 2:
                            decryptedItem = _context29.sent;
                            return _context29.abrupt("return", JSON.parse(decryptedItem.toString()));

                          case 4:
                          case "end":
                            return _context29.stop();
                        }
                      }
                    }, _callee29);
                  }));

                  return function (_x34) {
                    return _ref8.apply(this, arguments);
                  };
                }()));

              case 3:
                decryptedItems = _context30.sent;
                return _context30.abrupt("return", decryptedItems);

              case 5:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function getTKeyStore(_x33) {
        return _getTKeyStore.apply(this, arguments);
      }

      return getTKeyStore;
    }()
  }, {
    key: "getTKeyStoreItem",
    value: function () {
      var _getTKeyStoreItem = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee32(moduleName, id) {
        var _this9 = this;

        var rawTkeyStoreItems, decryptedItems, item;
        return regenerator_default.a.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                rawTkeyStoreItems = this.metadata.getTkeyStoreDomain(moduleName) || [];
                _context32.next = 3;
                return Promise.all(rawTkeyStoreItems.map( /*#__PURE__*/function () {
                  var _ref9 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee31(x) {
                    var decryptedItem;
                    return regenerator_default.a.wrap(function _callee31$(_context31) {
                      while (1) {
                        switch (_context31.prev = _context31.next) {
                          case 0:
                            _context31.next = 2;
                            return _this9.decrypt(x);

                          case 2:
                            decryptedItem = _context31.sent;
                            return _context31.abrupt("return", JSON.parse(decryptedItem.toString()));

                          case 4:
                          case "end":
                            return _context31.stop();
                        }
                      }
                    }, _callee31);
                  }));

                  return function (_x37) {
                    return _ref9.apply(this, arguments);
                  };
                }()));

              case 3:
                decryptedItems = _context32.sent;
                item = decryptedItems.find(function (x) {
                  return x.id === id;
                });
                return _context32.abrupt("return", item);

              case 6:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));

      function getTKeyStoreItem(_x35, _x36) {
        return _getTKeyStoreItem.apply(this, arguments);
      }

      return getTKeyStoreItem;
    }() // Import export shares

  }, {
    key: "outputShare",
    value: function () {
      var _outputShare = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee33(shareIndex, type) {
        var share;
        return regenerator_default.a.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                share = this.outputShareStore(shareIndex).share.share;

                if (type) {
                  _context33.next = 3;
                  break;
                }

                return _context33.abrupt("return", share);

              case 3:
                return _context33.abrupt("return", this.shareSerializationMiddleware.serialize(share, type));

              case 4:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, this);
      }));

      function outputShare(_x38, _x39) {
        return _outputShare.apply(this, arguments);
      }

      return outputShare;
    }()
  }, {
    key: "inputShare",
    value: function () {
      var _inputShare = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee34(share, type) {
        var shareStore, deserialized, pubPoly, pubPolyID, fullShareIndexesList;
        return regenerator_default.a.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                if (type) {
                  _context34.next = 4;
                  break;
                }

                shareStore = this.metadata.shareToShareStore(share);
                _context34.next = 8;
                break;

              case 4:
                _context34.next = 6;
                return this.shareSerializationMiddleware.deserialize(share, type);

              case 6:
                deserialized = _context34.sent;
                shareStore = this.metadata.shareToShareStore(deserialized);

              case 8:
                pubPoly = this.metadata.getLatestPublicPolynomial();
                pubPolyID = pubPoly.getPolynomialID();
                fullShareIndexesList = Object.keys(this.metadata.publicShares[pubPolyID]);

                if (fullShareIndexesList.includes(shareStore.share.shareIndex.toString("hex"))) {
                  _context34.next = 13;
                  break;
                }

                throw errors["default"]("Latest poly doesn't include this share");

              case 13:
                _context34.next = 15;
                return this.inputShareStoreSafe(shareStore);

              case 15:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this);
      }));

      function inputShare(_x40, _x41) {
        return _inputShare.apply(this, arguments);
      }

      return inputShare;
    }()
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        shares: this.shares,
        enableLogging: this.enableLogging,
        privKey: this.privKey ? this.privKey.toString("hex") : undefined,
        metadata: this.metadata
      };
    }
  }], [{
    key: "fromJSON",
    value: function () {
      var _fromJSON = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee35(value, args) {
        var enableLogging, privKey, metadata, shares, storageLayer, serviceProvider, modules, tb, key, shareStoreMapElement, shareElementKey, shareStore;
        return regenerator_default.a.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                enableLogging = value.enableLogging, privKey = value.privKey, metadata = value.metadata, shares = value.shares;
                storageLayer = args.storageLayer, serviceProvider = args.serviceProvider, modules = args.modules;
                tb = new ThresholdKey({
                  enableLogging: enableLogging,
                  storageLayer: storageLayer,
                  serviceProvider: serviceProvider,
                  modules: modules
                });
                if (privKey) tb.privKey = new external_bn_js_default.a(privKey, "hex");
                if (metadata) tb.metadata = src_metadata.fromJSON(metadata);

                for (key in shares) {
                  if (Object.prototype.hasOwnProperty.call(shares, key)) {
                    shareStoreMapElement = shares[key];

                    for (shareElementKey in shareStoreMapElement) {
                      if (Object.prototype.hasOwnProperty.call(shareStoreMapElement, shareElementKey)) {
                        shareStore = shareStoreMapElement[shareElementKey];
                        shareStoreMapElement[shareElementKey] = common_types_["ShareStore"].fromJSON(shareStore);
                      }
                    }
                  }
                }

                tb.shares = shares;
                _context35.next = 9;
                return tb.initialize();

              case 9:
                return _context35.abrupt("return", tb);

              case 10:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35);
      }));

      function fromJSON(_x42, _x43) {
        return _fromJSON.apply(this, arguments);
      }

      return fromJSON;
    }()
  }]);

  return ThresholdKey;
}();

/* harmony default export */ var core = (core_ThresholdKey);
// CONCATENATED MODULE: ./index.ts






/***/ })
/******/ ]);